const notifications = {
  apiClient: null,
  path: '/franchises/notifications',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getByBranch(branchId, category = null, beforeId = null) {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (beforeId) params.append('before_id', beforeId);
    const query = params.toString();
    const base = `${this.path}/branch/${branchId}`;
    const response = await this.apiClient.get(query ? `${base}?${query}` : base);
    return response.data;
  },

  async confirm(id) {
    const response = await this.apiClient.put(`${this.path}/${id}/confirm`);
    return response.data;
  },

  async confirmAll(branchId) {
    const response = await this.apiClient.put(`${this.path}/branch/${branchId}/confirm`);
    return response.data;
  },

  async destroy(id) {
    const response = await this.apiClient.delete(`${this.path}/${id}`);
    return response.data;
  },

  async clear(branchId, { category = null, scope = 'read' } = {}) {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (scope) params.append('scope', scope);
    const response = await this.apiClient.delete(`${this.path}/branch/${branchId}/clear?${params.toString()}`);
    return response.data;
  },
};

export default notifications;
